<!--联系我们 Sag 2020-03-26-->
<template>
  <div class="its-about-connect-us">
    <class-title class="its-about-e-class-title" :title="item.title"></class-title>
    <div class="its-desc" style="display:none">{{item.desc}}</div>
    <div class="its-connect-details">
      <div class="its-connect-details-item">
        <div class="its-connect-item-container">
          <div class="its-title">渠道合作</div>
          <!-- <div class="its-item-desc margin-15" style="height: 51px"> -->
            <!-- <span class="its-name">联系电话：</span>
            <span>010-57103453</span>
            <div class="its-time">工作日：8:30-18:00</div> -->
          <!-- </div> -->
          <div class="its-item-desc margin-15">
            <span class="its-name">Tel：</span>
            <span>18101357219</span>
            <div class="its-time">（微信同号）</div>
          </div>
          <img src="../../../../assets/images/download/qdhz.png" style="width:122px">
          <!-- <div class="its-item-desc">
            <span class="its-name">Email：</span>
            <span>partner@xkw.cn</span>
            <div class="its-time">工作日：8:30-18:00</div>
          </div> -->

          <!-- <div class="its-item-desc" v-for="(contact,i) in item.contacts" :key="i"><span class="its-name" :class="{'its-hidden':contact.hideName}">{{contact.name}}：</span><span>{{contact.num}}</span></div> -->
        </div>
      </div>
      <div class="its-connect-details-item ">
        <div class="its-connect-item-container its-center">
          <div class="its-title">售后服务</div>
          <div class="item-desc">若您在使用过程中有任何问题或建议，欢迎QQ咨询反馈</div>
          <div class="its-item-desc" v-for="(qq,i) in item.QQ" :key="i">{{qq.name}}：{{qq.qq}}</div>
        </div>
      </div>
      <div class="its-connect-details-item">
        <div class="its-qr-code">
          <img src="../../../../assets/images/about_qr_code.jpg">
          <div class="its-qr-name">微信公众号</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ClassTitle from '../../home/components/ClassTitle'
export default {
  name: 'AboutConnectUs',
  components: {
    ClassTitle
  },
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  }
}
</script>
<style scoped>
.its-about-connect-us{
  width: 1070px;
  margin: 0 auto;
}
.its-desc{
  color: #3F466A;
  font-size: 18px;
  line-height: 1;
  margin-top: 70px;
}
.its-connect-details{
  margin-top: 45px;
}
.its-connect-details-item{
  width: calc(100% / 3);
  height: 275px;
  border-left: 1px solid #a0baf8;
  display: inline-block;
  position: relative;
}
.its-connect-details-item:first-child{
  border: none;
}
.its-connect-item-container{
  position: absolute;
  top: 15px;
}
.its-connect-item-container.its-center{
  width: 100%;
  text-align: center;
}
.its-item-desc{
  font-size: 18px;
  color: #3F466A;
  line-height: 36px;
  font-family:PingFang SC;
  font-weight:400;
  margin-bottom: 15px;
}
.its-hidden{
  visibility: hidden;
}
.its-align-center{
  text-align: center;
}
.its-align-right{
  text-align: right;
}
.its-qr-code{
  position: absolute;
  right: 40px;
  top: 55px;
  text-align: center;
}
.its-qr-code .its-qr-name{
  color: #3F466A;
  font-size: 18px;
  margin-top: 5px;
  line-height: 1;
}

.its-qr-code img {
  width: 143px;
  height: 143px;
}
.its-title {
  font-size: 22px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 20px;
  text-align: center;
}
.item-desc {
  margin: 0 20px;
  text-align: left;
  font-size: 16px;
  margin-bottom: 10px;
  color: #666666;
}
.its-time{
  line-height: 1.1;
  font-size: 14px;
  color: #666666;
}
</style>